/* eslint-disable */
export default {
  'ja-JP': {
    common: {
      NAME_HOLDER: "名前 *",
      LAST_NAME_HOLDER: "名字 *",
      EMAIL_HOLDER: "メールアドレス *",
      PASS_HOLDER: "パスワードを作成 *",
      REPEAT_PASS_HOLDER: "パスワードを再度記入 *",
      BUTTON_EMAIL_SIGN_UP: "メールアドレスで登録",

      TERMS_AND_CONDITIONS: "規約と条件",
      PRIVACY_POLICY: "個人情報保護方針",

      NEWSLETTER_CONSENT: "Time Outから最新のニュース、イベント、オファーおよびパートナープロモーションに関するメールを受け取ることに同意します",
      TERM_OF_USE: "私は{{terms_and_conditions}}そして{{privacy_policy}} Time Out の",
      TERM_OF_USE_WITH_NEWSLETTERS: "タイムアウトの規約に合意します（メルマガ会員登録も含める）",

      HEADER_TITLE: "タイムアウトアカウントを作成",
      JOIN_FB: "フェイスブックで登録",
      JOIN_TW: "ツイッターで登録",
      JOIN_GG: "グーグルで登録",
      JOIN_EM: "メールアドレスで登録",
      ALREADY_HAVE: "既にタイムアウトアカウントをお持ちですか？",
      CREATE_ACCOUNT_LOG_IN: "ログイン",

      SIGN_IN_TITLE: "サインイン",
      SIGN_IN_FB: "フェイスブックでログイン",
      SIGN_IN_TW: "ツイッターでログイン",
      SIGN_IN_GG: "グーグルでログイン",
      SIGN_IN_EM: "メールアドレスでログイン",
      YOUR_EMAIL: "メールアドレス",
      YOUR_PASSWORD: "パスワード",
      REMEMBER: "Remember me",
      FORGOT: "忘れた方",
      HAVE_ACCOUNT_YET: "まだタイムアウトアカウントをお持ちでない方",
      JOIN_HERE: "登録はこちら",
      ALMOST_THERE: "ほぼそこに",

      FORGOT_HEADER: "パスワードを忘れた方",
      FORGOT_SUBTITLE: "メールアドレスを記入ください。パスワードをリセットするためのリンクが送られます。",
      SEND_LINK: "送信",

      RECEIVE_EMAIL: "メールが送信されます",
      MANAGE_ACCOUNT: "アカウントを確認する",
      EDIT_DETAILS_HERE: "登録内容の修正",
      FIRST_NAME: "名前",
      LAST_NAME: "名字",
      SCREEN_NAME: "スクリーンネーム",
      EMAIL: "メールアドレス",
      ACCOUNT_DETAILS: "アカウント情報",
      PASSWORD: "パスワード",
      SAVE_CHANGES: "変更を保存する",
      UPLOAD_PIC: "新しいプロフィール写真をアップロード",
      CHOOSE_PHOTO: "写真を選択（容量上限は2MB）",
      CLOSE_ACCOUNT: "アカウントを閉じる",
      PASSWORD_BELOW: "パスワードを変更する",
      CURRENT_PASSWORD: "現状のパスワード",
      NEW_PASSWORD: "新しいパスワード",
      REPEAT_PASSWORD: "新しいパスワードを再度記入",

      OOPS: "エラー",
      ERROR_404_OCCURED: "エラーが起きました",
      ERROR_404_INFO: "ページは移動されたか、存在しません",
      ERROR_500_TITLE: "サーバーに接続できません",
      SMTH_BROKEN: "エラー",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "エラーが発生した際の状況をご連絡ください。早急に確認します。ご迷惑をおかけし申し訳ございません。",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "正しいメールアドレスをご記入ください。",
      FIRST_NAME_ERROR: "あなたの名前を入力してください",
      LAST_NAME_ERROR: "あなたの姓を入力してください",
      TERM_OF_USE_ERROR: "利用規約に同意する必要があります",
      SIGN_IN_VALIDATION_ERROR: "メールアドレスかパスワードが違います。再度ご記入ください。",
      ACCOUNT_PASSWORDS_VALIDATION: "パスワードが合いません",
      WAS_IT: "アカウント削除の理由があればご記入ください",
      DELETE_ACCOUNT_TEXT: "アカウント削除の理由があればご記入ください",
      DELETE_ACCOUNT: "アカウントを削除する",
      CANCEL: "キャンセル",

      UPDATE_PASSWORD: "パスワードを更新する",
      PASSWORD_UPDATE_SUCCESS: "パスワードが更新されました",
      ERROR_PASSWORD_LENGTH: "パスワードは6文字以上でなければなりません",

      ERROR_MISSING_SITE_PARAMETER: "必須のアプリケーションパラメータがありません： site",
      ERROR_ALREADY_REGISTERED: "あなたはすでにメールサインアップを使用して登録されています。 {{email}}を使用してログインしてください",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/ja-JP.js